import React from 'react';
import Button from '../components/ui/Button';
import Icon from '../components/AppIcon';
import useTranslation from '../hooks/useTranslation';

const ServiceUnavailable = ({ onRetry }) => {
  const { t } = useTranslation(['serviceUnavailable', 'common']);

  return (
    <div className="min-h-screen flex items-center justify-center bg-background px-4">
      <div className="max-w-lg w-full text-center">
        <div className="flex justify-center mb-6">
          <div className="bg-secondary/20 rounded-full p-4">
            <Icon name="ServerCrash" className="w-12 h-12 text-primary" />
          </div>
        </div>

        <h1 className="text-3xl font-semibold text-onBackground mb-3">
          {t('serviceUnavailable.title', 'Service Temporarily Unavailable')}
        </h1>

        <p className="text-onBackground/70 mb-8">
          {t(
            'serviceUnavailable.description',
            "We're having trouble reaching the backend services right now. Please try again in a moment or contact your administrator if the issue persists.",
          )}
        </p>

        {onRetry && (
          <div className="flex justify-center">
            <Button variant="primary" icon={<Icon name="RefreshCw" />} onClick={onRetry}>
              {t('serviceUnavailable.retryConnection', 'Retry Connection')}
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};

export default ServiceUnavailable;
